import React, { useEffect, useRef, useState } from "react";
import DailyIframe from "@daily-co/daily-js";

const ROOM_URL = "https://ini.daily.co/test";

export default function AdminJoin() {
  const frameRef = useRef(null);
  const containerRef = useRef(null);
  const [joined, setJoined] = useState(false);
  const [error, setError] = useState(null);
  const [participantCount, setParticipantCount] = useState(0);

  const theme = {
    colors: {
      accent: "#1F74EC",
      accentText: "#172447",
      background: "#111725",
      backgroundAccent: "#F692AC",
      baseText: "#F7F7F7",
      border: "#728ED8",
      mainAreaBg: "#172447",
      mainAreaBgAccent: "#334985",
      mainAreaText: "#EEEEEE",
      supportiveText: "#ADCFFF",
    },
  };

  // Notify Flutter app that user interacted with the iframe
  const notifyFlutter = () => {
    if (window.print && window.print.postMessage) {
      window.print.postMessage("User pressed inside Daily room");
    }
  };

  useEffect(() => {
    // Set body styles for fullscreen
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100%";

    // Fetch token for admin role
    fetch("https://iniserve.com/api/room/getmytoken?role=admin")
      .then((res) => res.json())
      .then(({ token }) => {
        if (!containerRef.current) {
          setError("Internal error: container not found");
          return;
        }

        // Create Daily iframe with configured options
        frameRef.current = DailyIframe.createFrame(containerRef.current, {
          theme,
          videoSource: false,
          audioSource: true,
          showFullscreenButton: false,
          showLeaveButton: false,
          startVideoOff: true,
          customLayout: true,
          showLocalVideo: false,
        });

        // Join the room with token
        frameRef.current
          .join({ url: ROOM_URL, token })
          .then(() => {
            setJoined(true);
            setError(null);

            // Notify Flutter app that admin connected
            if (window.parent) {
              window.parent.postMessage("admin-connected", "*");
            }
          })
          .catch((error) => {
            const msg =
              error?.message?.toLowerCase().includes("room is full") ||
              error?.message?.toLowerCase().includes("max participants")
                ? "Room is full, please wait."
                : "Failed to join the room. Please try again later.";
            setError(msg);
            setJoined(false);
          });

        // Function to update participant count
        function updateCount() {
          if (!frameRef.current) return;
          const participants = frameRef.current.participants();
          const count = Object.keys(participants).length;
          setParticipantCount(count);
        }

        // Setup event listeners for participant events
        frameRef.current.on("participant-joined", updateCount);
        frameRef.current.on("participant-left", updateCount);
        frameRef.current.on("participants-changed", updateCount);
        frameRef.current.on("joined-meeting", updateCount);

        // Cleanup event listeners on unmount or re-render
        return () => {
          if (frameRef.current) {
            frameRef.current.off("participant-joined", updateCount);
            frameRef.current.off("participant-left", updateCount);
            frameRef.current.off("participants-changed", updateCount);
            frameRef.current.off("joined-meeting", updateCount);
          }
        };
      });

    // Attach user interaction listeners to notify Flutter
    const container = containerRef.current;
    if (container) {
      container.addEventListener("pointerdown", notifyFlutter, true);
      container.addEventListener("keydown", notifyFlutter, true);
    }

    // Handle messages from Flutter regarding mic and end call
    const handleMicMessage = (event) => {
      if (!frameRef.current) return;

      if (event.data === "mic-on") {
        frameRef.current.setLocalAudio(true);
        window.parent.postMessage({ micOn: true }, "*");
      }
      if (event.data === "mic-off") {
        frameRef.current.setLocalAudio(false);
        window.parent.postMessage({ micOn: false }, "*");
      }
    };
    window.addEventListener("message", handleMicMessage);

    // Cleanup on component unmount
    return () => {
      if (frameRef.current) {
        frameRef.current.leave();
        frameRef.current.destroy();
        if (window.parent) {
          window.parent.postMessage("admin-disconnected", "*");
        }
      }
      document.body.style.overflow = "";
      if (container) {
        container.removeEventListener("pointerdown", notifyFlutter, true);
        container.removeEventListener("keydown", notifyFlutter, true);
      }
      window.removeEventListener("message", handleMicMessage);
    };
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#000",
      }}
    >
      {/* Daily.co iframe container */}
      <div
        ref={containerRef}
        tabIndex={0}
        style={{
          width: "100%",
          height: "100%",
          transform: "none",
        }}
      ></div>

      {/* Error message display */}
      {error && (
        <div
          style={{
            position: "absolute",
            top: 60,
            left: "50%",
            transform: "translateX(-50%)",
            color: "red",
            fontWeight: "bold",
            zIndex: 31,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}

// import React, { useEffect, useRef, useState } from "react";
// import DailyIframe from "@daily-co/daily-js";

// const ROOM_URL = "https://ini.daily.co/test";

// export default function AdminJoin() {
//   const frameRef = useRef(null);
//   const containerRef = useRef(null);
//   const [joined, setJoined] = useState(false);
//   const [error, setError] = useState(null);
//   const [participantCount, setParticipantCount] = useState(0);

//   const theme = {
//     colors: {
//       accent: "#1F74EC",
//       accentText: "#172447",
//       background: "#111725",
//       backgroundAccent: "#F692AC",
//       baseText: "#F7F7F7",
//       border: "#728ED8",
//       mainAreaBg: "#172447",
//       mainAreaBgAccent: "#334985",
//       mainAreaText: "#EEEEEE",
//       supportiveText: "#ADCFFF",
//     },
//   };

//   // Notify Flutter app that user interacted with the iframe
//   const notifyFlutter = () => {
//     if (window.print && window.print.postMessage) {
//       window.print.postMessage("User pressed inside Daily room");
//     }
//   };

//   useEffect(() => {
//     // Set body styles for fullscreen
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";
//     document.body.style.overflow = "hidden";
//     document.documentElement.style.height = "100%";

//     // Fetch token for admin role
//     fetch("https://iniserve.com/api/room/getmytoken?role=admin")
//       .then((res) => res.json())
//       .then(({ token }) => {
//         if (!containerRef.current) {
//           setError("Internal error: container not found");
//           return;
//         }

//         // Create Daily iframe with configured options
//         frameRef.current = DailyIframe.createFrame(containerRef.current, {
//           theme,
//           videoSource: false,
//           audioSource: true,
//           showFullscreenButton: false,
//           showLeaveButton: false,
//           startVideoOff: true,
//           customLayout: true,
//           showLocalVideo: false,
//         });

//         // Join the room with token
//         frameRef.current
//           .join({ url: ROOM_URL, token })
//           .then(() => {
//             setJoined(true);
//             setError(null);

//             // Notify Flutter app that admin connected
//             if (window.parent) {
//               window.parent.postMessage("admin-connected", "*");
//             }
//           })
//           .catch((error) => {
//             const msg =
//               error?.message?.toLowerCase().includes("room is full") ||
//               error?.message?.toLowerCase().includes("max participants")
//                 ? "Room is full, please wait."
//                 : "Failed to join the room. Please try again later.";
//             setError(msg);
//             setJoined(false);
//           });

//         // Function to update participant count
//         function updateCount() {
//           if (!frameRef.current) return;
//           const participants = frameRef.current.participants();
//           const count = Object.keys(participants).length;
//           setParticipantCount(count);
//         }

//         // Setup event listeners for participant events
//         frameRef.current.on("participant-joined", updateCount);
//         frameRef.current.on("participant-left", updateCount);
//         frameRef.current.on("participants-changed", updateCount);
//         frameRef.current.on("joined-meeting", updateCount);

//         // Cleanup event listeners on unmount or re-render
//         return () => {
//           if (frameRef.current) {
//             frameRef.current.off("participant-joined", updateCount);
//             frameRef.current.off("participant-left", updateCount);
//             frameRef.current.off("participants-changed", updateCount);
//             frameRef.current.off("joined-meeting", updateCount);
//           }
//         };
//       });

//     // Attach user interaction listeners to notify Flutter
//     const container = containerRef.current;
//     if (container) {
//       container.addEventListener("pointerdown", notifyFlutter, true);
//       container.addEventListener("keydown", notifyFlutter, true);
//     }

//     // Handle messages from Flutter regarding mic and end call
//     const handleMicMessage = (event) => {
//       if (!frameRef.current) return;

//       if (event.data === "mic-on") {
//         frameRef.current.setLocalAudio(true);
//         window.parent.postMessage({ micOn: true }, "*");
//       }
//       if (event.data === "mic-off") {
//         frameRef.current.setLocalAudio(false);
//         window.parent.postMessage({ micOn: false }, "*");
//       }
//     };
//     window.addEventListener("message", handleMicMessage);

//     // Cleanup on component unmount
//     return () => {
//       if (frameRef.current) {
//         frameRef.current.leave();
//         frameRef.current.destroy();
//         if (window.parent) {
//           window.parent.postMessage("admin-disconnected", "*");
//         }
//       }
//       document.body.style.overflow = "";
//       if (container) {
//         container.removeEventListener("pointerdown", notifyFlutter, true);
//         container.removeEventListener("keydown", notifyFlutter, true);
//       }
//       window.removeEventListener("message", handleMicMessage);
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         height: "100vh",
//         width: "100vw",
//         margin: 0,
//         padding: 0,
//         overflow: "hidden",
//         position: "relative",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "#000",
//       }}
//     >
//       {/* Participant count display */}
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           background: "#111725",
//           color: "#FFF",
//           padding: "5px 0",
//           fontWeight: "bold",
//           fontSize: "18px",
//           textAlign: "center",
//           zIndex: 30,
//           letterSpacing: 1,
//         }}
//       >
//         Participants: {participantCount}
//       </div>

//       {/* Daily.co iframe container */}
//       <div
//         ref={containerRef}
//         tabIndex={0}
//         style={{
//           width: "100%",
//           height: "100%",
//           transform: "none",
//         }}
//       ></div>

//       {/* Error message display */}
//       {error && (
//         <div
//           style={{
//             position: "absolute",
//             top: 60,
//             left: "50%",
//             transform: "translateX(-50%)",
//             color: "red",
//             fontWeight: "bold",
//             zIndex: 31,
//           }}
//         >
//           {error}
//         </div>
//       )}

//       {/* Footer */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           background: "#111725",
//           color: "#FFF",
//           padding: "15px 0",
//           textAlign: "center",
//           fontSize: "18px",
//           fontWeight: "bold",
//           zIndex: 20,
//         }}
//       >
//         Iniserve
//       </div>
//     </div>
//   );
// }
